<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { IChallenge } from "../../entities/challenge";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { clfChallengeTypeCode, initDetail, onChallengeTypeChange, record, save, stats } from "./challenge.store";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import SectionDropdown from "../../components/Business/SectionDropdown.svelte";
  import ChallengeDetailTabs from "./ChallengeDetailTabs.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import AceEditorField from "../../components/Form/Fields/AceEditorField.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.name != "" && $record.memoryMb > 0 && $record.runtimeMs > 0;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IChallenge> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/challenge/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/challenge`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <ChallengeDetailTabs challengeId={oid} tasks={false} />

  {#if $record}
    <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
      <div class="columns">
        <div class="column is-8">
          <FormField>
            <Input name="Name" placeholder="name" required={true} bind:value={$record.name} />
          </FormField>
        </div>

        <div class="column is-4">
          <FormField>
            <Switch name="Active" bind:value={$record.active} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <FormField>
            <SectionDropdown name="Section" placeholder="section" required={true} bind:value={$record.sectionId} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <NumberInput name="Order" placeholder="order" required={true} bind:value={$record.order} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <NumberInput name="Difficulty" placeholder="difficulty" required={true} bind:value={$record.difficulty} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column is-3">
          <FormField>
            <ClfDropdown
              name="Type"
              schema="CHLLNGETYP"
              required={true}
              clearVisible={false}
              on:select={onChallengeTypeChange}
              bind:value={$record.clfChallengeTypeId}
            />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <ClfDropdown name="Comparator" schema="COMPARTYPE" required={true} clearVisible={false} bind:value={$record.clfComparatorId} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <NumberInput name="Runtime (ms)" placeholder="runtime" required={true} bind:value={$record.runtimeMs} />
          </FormField>
        </div>

        <div class="column is-3">
          <FormField>
            <NumberInput name="Memory (MiB)" placeholder="memory" required={true} bind:value={$record.memoryMb} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <FormField>
            <Textarea name="Statement" placeholder="statement" required={true} bind:value={$record.statement} />
          </FormField>
        </div>
      </div>

      {#if $clfChallengeTypeCode == "CTFUNCTION"}
        <div class="columns">
          <div class="column">
            <FormField>
              <AceEditorField name="Program Text (main)" required={true} bind:value={$record.programText} />
              <!--<Textarea name="Program Text (main)" placeholder="main program code" required={true} bind:value={$record.programText} />-->
            </FormField>
          </div>
        </div>
      {/if}
    </FormLayout>
  {/if}
</MainLayout>
